import React from 'react';
import { useIntl } from 'umi';
import { Button } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { IBaseProps } from '@/pages/intelligence/types/common';

interface IFollowBtnProps extends IBaseProps {
  // 已关注时的 按钮文案（激活状态）
  activeText?: string;
  // 未关注时的 按钮文案（未激活状态）
  deactiveText?: string;
  value: boolean;
  onClick?: (e?: React.MouseEvent<Element, MouseEvent>) => void;
  onChange?: (payload: boolean, e?: React.MouseEvent<Element, MouseEvent>) => Promise<any>;
}

const FollowBtn = (props: IFollowBtnProps) => {
  const { formatMessage } = useIntl();
  const {
    activeText = formatMessage({ id: 'dbi_following' }),
    deactiveText = formatMessage({ id: 'dbi_follow' }),
    value,
    onChange,
    onClick,
  } = props;

  const handleClick = (e?: React.MouseEvent<Element, MouseEvent>) => {
    e?.stopPropagation();
    e?.preventDefault();
    const valueTmp = !value;
    onChange?.(valueTmp, e);
    onClick?.(e);
  };

  return (
    <Button className="dbi-details-btn dbi-details-btn-bottom ns-btn--shadow dbi-following-btn" onClick={handleClick}>
      <SvgIcon className={value ? 'is-select' : 'no-change'} type={value ? 'star-action' : 'star-m'} />
      {value ? activeText : deactiveText}
    </Button>
  );
};

export default FollowBtn;
